import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/App'
import router from './router'
import store from './store'
import i18n from './language'

sync(store, router)

var Cookies = require('js-cookie');

var localEnviroment = window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("dev.desenio") > -1;

const app = new Vue({
  router,
  store,
  i18n,
  ...App
})

export { app, router, store, language, eventHub }



// WEBPACK FOOTER //
// ./client/app.js